import { Icon } from '@/components/Icon/Icon';
import { useClientTerminology } from '@/hooks/useClientTerminology';
import { Box, Text, Button } from '@mantine/core';
import { ExternalLink } from 'react-feather';
import { HELP_ARTICLES } from '@/helpers/helpArticles';

import classes from './RedFlagWarningCard.module.css';
import redFlagWarningInfoClasses from './RedFlagWarningInfo.module.css';

export function NoRedFlagWarningInfo() {
  const intl = useClientTerminology();

  return (
    <Box className={classes.noWarningsContainer}>
      <Text fw={500}>
        {intl.formatMessage({ id: 'redFlagWarning.noWarningsTitle' })}
      </Text>
      <Text className={classes.noWarningsBody}>
        {intl.formatMessage({ id: 'redFlagWarning.noWarningsBody' })}
      </Text>
      <Button
        variant="transparent"
        className={redFlagWarningInfoClasses.readMoreButton}
        component="a"
        href={HELP_ARTICLES.redFlagWarnings}
        target="_blank"
      >
        <Icon Component={ExternalLink} color="green" size={14} />
        <Text ml="xs" size="sm">
          {intl.formatMessage({ id: 'action.learnMore' })}
        </Text>
      </Button>
    </Box>
  );
}
